import { useState } from "react";
import "../Styles/Order.css"
import Navbar from "../components/Navbar"
import { Pagination } from "@mantine/core";
import ServiceCard from "../components/ServiceCard";
import Footer from "../components/Footer";
import { AiOutlineSearch } from "react-icons/ai";

const Order = () => {
    const [activePage, setPage] = useState(1);
    const [filterParam, setFilterParam] = useState("")

    return<>
        <Navbar/>

        <section className="search">
            <div className="searchInput">
                <AiOutlineSearch/>
                <input type="search" name="" id="" placeholder="Search Keyword..."/>
            </div>
        </section>
            <div className="userOrderContainer">

                <div className="userOrderWrapper">
                    <div className="orderCard">
                        <div className="orderCardHeading">
                            <div className="topHeading">
                                <h2>#405422</h2>
                                <p className="pending">pending</p>
                                
                                <p><span>Payment Status: </span>paid</p>
                            </div>
                            <div className="bottomHeading">
                                <p><span>Order date:</span>&nbsp; 12th Oct, 2023</p>
                                <p>Delivery date: 25th Oct 2023</p>
                            </div>
                        </div>
                        <div className="orderCardMiddle" >
                            <img src="" alt="" />
                            <div className="orderCardDetails">
                                <div className="topDetails">
                                    <h3>Cauliflower Plant</h3>
                                    <p>N40.0</p>
                                </div>
                                <div className="bottomDetails">
                                    <p><span>Category: </span>Leaves &nbsp;&nbsp;&nbsp;</p>
                                    <p><span>Qty</span>: 3</p>
                                </div>
                            </div>
                        </div>
                        
                        <div className="total">
                            <h3>Total: <span>N120.0</span></h3>
                        </div>
                        <div className="orderCardBottom">
                            <h2>Shipping Address</h2>
                            <div className="orderAddress">
                                <p>Edyco Plaza, First Mechanic Junction, East-West road</p>
                                <p>Port Harcourt</p>
                                <p>Rivers State</p>
                                <p>Nigeria</p>
                                
                            </div>
                        </div>
                    </div>
                </div>

            <div className="pagination">
                <Pagination
                    total={10}
                    value={activePage}
                    onChange={setPage}
                    boundaries={1}
                    color="rgb(2, 79, 2)"
                    size={window.innerWidth <= 400 ? "xs" : "md"}
                    className="paginate"
                />
            </div>
        </div>

        <ServiceCard/>
        <Footer/>

    </>

}

export default Order